import { Input } from "antd";
import debounce from "lodash.debounce";
import React, { useEffect, useMemo } from "react";

type InputChange = React.ChangeEventHandler<HTMLInputElement>;

interface SearchInputProps {
  placeholder?: string;
  cssClasses?: string;
  onSearch: InputChange;
}

const DEBOUNCE_TIME = 600;

const SearchInput = ({
  placeholder,
  onSearch,
  cssClasses,
}: SearchInputProps) => {
  const onChange = useMemo(() => debounce(onSearch, DEBOUNCE_TIME), [onSearch]);

  useEffect(() => {
    return () => {
      onChange.cancel();
    };
  }, [onChange]);

  return (
    <Input
      placeholder={placeholder || "Search"}
      allowClear
      className={cssClasses}
      onChange={onChange}
    />
  );
};

export default SearchInput;
